export enum NewWorkflowActionKind {
  SET_FORMS,
  SET_ISLOADING,
  SET_WORKFLOW_TYPE,
  SET_NEW_WORKFLOW_NAME,
  SET_ERROR,
  SET_ERROR_MESSAGE,
  SET_SELECTED_FORM,
  SET_SELECTED_FORM_ID
}

export enum WorkflowTypes {
  OHS = 'OHS',
  OWT = 'Other'
}

export interface WorkflowService {
  serviceId: string;
  serviceName: string;
}

export interface WorkflowServiceList {
  dynamicWorkflowServices: WorkflowService[];
}

interface NewWorkflowAction {
  type: NewWorkflowActionKind;
  payload?: WorkflowService[] | boolean | string | WorkflowTypes | null;
}

interface NewWorkflowState {
  forms: WorkflowService[];
  isLoading: boolean;
  workflowType: WorkflowTypes;
  newWorkflowName: string;
  hasError: boolean;
  errorMessage: string;
  selectedForm: string | null;
  selectedId: string;
}

export const initialState: NewWorkflowState = {
  forms: [],
  isLoading: false,
  workflowType: WorkflowTypes.OHS,
  newWorkflowName: '',
  hasError: false,
  errorMessage: '',
  selectedForm: null,
  selectedId: ''
};

export function newWorkflowReducer(
  state: NewWorkflowState,
  action: NewWorkflowAction
) {
  const { type, payload } = action;

  switch (type) {
    case NewWorkflowActionKind.SET_FORMS:
      return {
        ...state,
        forms: payload as WorkflowService[]
      };

    case NewWorkflowActionKind.SET_ISLOADING:
      return {
        ...state,
        isLoading: payload as boolean
      };

    case NewWorkflowActionKind.SET_WORKFLOW_TYPE:
      return {
        ...state,
        workflowType: payload as WorkflowTypes
      };

    case NewWorkflowActionKind.SET_NEW_WORKFLOW_NAME:
      return {
        ...state,
        newWorkflowName: payload as string
      };

    case NewWorkflowActionKind.SET_ERROR:
      return {
        ...state,
        hasError: payload as boolean
      };

    case NewWorkflowActionKind.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload as string
      };

    case NewWorkflowActionKind.SET_SELECTED_FORM:
      return {
        ...state,
        selectedForm: payload as string
      };

    case NewWorkflowActionKind.SET_SELECTED_FORM_ID:
      return {
        ...state,
        selectedId: payload as string
      };

    default:
      return state;
  }
}
